<app-card-content [border]="false" [headerColor]="true" icon="pi pi-video" title="Telemedicina">
    <div card-header>
        @if (selectedTab === 'ATIVAS') {
            <app-botao-acoes [label]="'Ações'" [items]="hashableOptionsTab.get('ATIVAS')?.actions?.items ?? []" [appCan]="roleTelemedicinaEditar" [appCanUf]="pessoa()?.uf" />
        }
    </div>

    <app-tab-container class="telemedicina-tab-switch" [options]="optionsTab" [(selected)]="selectedTab" (onChanged)="onTabChanged($event)" [useHeader]="false">
        <app-tab-content [value]="'ATIVAS'">
            <app-custom-table [data]="rows()" [metadata]="metadata" [columnOrder]="tableColumnOrder" [loading]="loading()" [rowClickable]="true" (onRowClick)="onRowClickAtivas($event)" />
            <app-telemedicina-editar-dialog [(showDialog)]="displayDialog" [tipos]="tipos()" (saved)="onDialogSaved($event)" (canceled)="onDialogCanceled()" />
            <app-encerrar-telemedicina-dialog [(showDialog)]="displayEncerrarDialog" [tipo]="selectedTipo" [(dataFim)]="encerrarDataFim" (saved)="onEncerrarSaved($event)" (canceled)="onEncerrarCanceled()" />
        </app-tab-content>

        <app-tab-content [value]="'HISTORICO'">
            <app-custom-table [data]="rows()" [metadata]="metadata" [columnOrder]="tableColumnOrder" [loading]="loading()" />
        </app-tab-content>
    </app-tab-container>
</app-card-content>
